import type { GameDescriptor } from '../game-registry.js';
import type { SceneComponent } from '../scenes/types.js';

// Plinko renders via its own concurrent-drop view (shell/PlinkoGameView), bypassing the shared
// GameStage/SingleShotGameView path — so this scene is never mounted. It exists only to satisfy
// the GameDescriptor.scene type; GamePage dispatches plinko to PlinkoGameView before any scene
// is built. The real animation lives in scenes/plinko/PlinkoScene.tsx.
const unusedPlinkoScene: SceneComponent = () => null as never;

export const plinkoDescriptor: GameDescriptor = {
  code: 'plinko',
  scene: unusedPlinkoScene,
  supportsAuto: true,
  selectable: false,
};
